import PropTypes from 'prop-types';

const CreditCard = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M16 4.25A2.75 2.75 0 0 1 18.75 7v7A2.75 2.75 0 0 1 16 16.75H4A2.75 2.75 0 0 1 1.25 14V7A2.75 2.75 0 0 1 4 4.25zM2.75 13v1c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-1zM4 5.75c-.69 0-1.25.56-1.25 1.25v4h14.5V7c0-.69-.56-1.25-1.25-1.25z"
            fill={color}
        />
    </svg>
);

export default CreditCard;

CreditCard.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
